/**
 * Hook: useScheduledMeetingsQuery
 *
 * Provides read-only access to scheduled meetings state and fetching functions.
 * This is the "reading" part of the context interface.
 *
 * It calls the master `useScheduledMeetings` hook internally and exposes
 * only the state and query-related functions.
 */
import useScheduledMeetings from './useScheduledMeetings';

const useScheduledMeetingsQuery = () => {
  const {
    meetings,
    lastPageMeetings,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isInitialized,
    error,
    hasNextPage,
    fetchNextPage,
    totalCount,
    lastFetchedAt,
    getMeetings,
    getAllMeetingsFlat,
    getMeeting,
    refreshMeetings,
    getMeetingByRoom,
    isMeetingOwned,
  } = useScheduledMeetings();

  return {
    meetings,
    lastPageMeetings,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isInitialized,
    error,
    hasNextPage,
    fetchNextPage,
    totalCount,
    lastFetchedAt,
    getMeetings,
    getAllMeetingsFlat,
    getMeeting,
    refreshMeetings,
    getMeetingByRoom,
    isMeetingOwned,
  };
};

export default useScheduledMeetingsQuery;
